import React, { useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Checkbox,
  Row,
  Col,
  message,
  Upload,
  Spin,
} from "antd";
import App from "../../Utils/LayoutMobile";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserById,
  updateUser,
} from "../../features/userSlice";
const { Option } = Select;

const UpdateUser = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigation = useNavigate();
  const dispatch = useDispatch();
  let{ loading, success, error, selectedUser } = useSelector(
    (state) => state.user
  );

  // Fetch user by ID when component mounts
  useEffect(() => {
    if (id) {
      dispatch(getUserById(id));
    }
  }, [id, dispatch]);

  // Set form values once user data is fetched
  useEffect(() => {
    if (selectedUser) {
      form.setFieldsValue({
        ...selectedUser,
        image: selectedUser.image
          ? [
              {
                uid: "-1",
                name: "image.png",
                status: "done",
                url: selectedUser.image,
              },
            ]
          : [],
      });
    }
  }, [selectedUser, form]);

  useEffect(() => {
    if (success) {
      message.success("User updated successfully");
      success=false
      navigation("/Users");

    }
    if (error) {
      message.error(error);
    }
  }, [success, error, navigation]);

  const handleSubmit = (values) => {
   try{

    console.log("::values::", values);
  
    const formData = new FormData();
  
    Object.keys(values).forEach((key) => {
      if (key === "image") {
        const imageFile = values[key]?.[0];
  
        if (imageFile?.originFileObj) {
          // New image selected
          formData.append("image", imageFile.originFileObj);
        } else if (imageFile?.url) {
          // Existing image (still want to pass it as reference)
          formData.append("imageUrl", imageFile.url); // Backend can handle this separately
        }
      } else {
        formData.append(key, values[key]);
      }
    });
  
    // Debug FormData
    for (let [key, value] of formData.entries()) {
      console.log( `${key}:`, value);
    }

    dispatch(updateUser({formData,id}));
  }catch(error){
    
    console.log("error wile handelling update",error)

  }
  };

  return (
    <App>
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{ status: false }}
        >
          {/* <Row gutter={16}>
            <Col xs={24} md={8}>
              <Form.Item name="username" label="Username">
                <Input />
              </Form.Item>

              <Form.Item
                name="name"
                label="Full Name"
                rules={[
                  { required: true, message: "Please enter your Full name" },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item name="mname" label="Middle Name">
                <Input />
              </Form.Item>

              <Form.Item name="lName" label="Last Name">
                <Input />
              </Form.Item>

              <Form.Item
                name="country"
                label="Country"
                rules={[
                  { required: true, message: "Please enter your country" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24} md={8}>
              <Form.Item
                name="specialty"
                label="Specialty"
                rules={[
                  { required: true, message: "Please enter your specialty" },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { type: "email", message: "Invalid email" },
                  { required: true, message: "Please enter your email" },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="mobile"
                label="Mobile"
                rules={[
                  {
                    required: true,
                    message: "Please enter your mobile number",
                  },
                  {
                    pattern: /^\d{10}$/,
                    message: "Mobile number must be exactly 10 digits",
                  },
                ]}
              >
                <Input
                  maxLength={10}
                  onChange={(e) => {
                    const onlyDigits = e.target.value.replace(/\D/g, "");
                    form.setFieldsValue({ mobile: onlyDigits });
                  }}
                />
              </Form.Item>

              <Form.Item
                name="whatAppNumber"
                label="WhatsApp Number"
                rules={[
                  {
                    pattern: /^\d{10}$/,
                    message: "WhatsApp number must be exactly 10 digits",
                  },
                ]}
              >
                <Input
                  maxLength={10}
                  onChange={(e) => {
                    const onlyDigits = e.target.value.replace(/\D/g, "");
                    form.setFieldsValue({ whatAppNumber: onlyDigits });
                  }}
                />
              </Form.Item>

              <Form.Item name="Qualification" label="Qualification">
                <Input />
              </Form.Item>

              <Form.Item name="role" label="Role">
                <Select placeholder="Select role">
                  <Option value="admin">Admin</Option>
                  <Option value="user">User</Option>
                  <Option value="faculty">Faculty</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} md={8}>
        
              <Form.Item name="location" label="Location">
                <Input />
              </Form.Item>

              <Form.Item name="full_name" label="Full Name">
                <Input />
              </Form.Item>

              <Form.Item
                name="image"
                label="Image"
                valuePropName="fileList"
                getValueFromEvent={(e) => e.fileList}
              >
                <Upload
                  name="image"
                  listType="picture"
                  beforeUpload={() => false}
                  maxCount={1}
                >
                  <Button>Select Image</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <div style={{ textAlign: "right" }}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ marginRight: 8 }}
              >
                Update User
              </Button>
              <Button
                danger
                onClick={() => {
                  navigation("/Users");
                }}
              >
                Cancel
              </Button>
            </div>
          </Form.Item> */}
           <Row gutter={[16, 16]}>
                      <Col span={24}>
                        <h2 style={{ marginBottom: 30 }}>Update Faculty</h2>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="name"
                          label="Full Name"
                          rules={[
                            { required: true, message: "Please enter your full name" },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
          
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="email"
                          label="Email"
                          rules={[
                            { type: "email", message: "Invalid email" },
                            { required: true, message: "Please enter your email" },
                          ]}
                        >
                          <Input />
                        </Form.Item>
          
                        <Form.Item name="role" initialValue="faculty" hidden>
                          <Input />
                        </Form.Item>
                      </Col>
          
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="location"
                          label="Location"
                          rules={[
                            { required: true, message: "Please enter your full name" },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
          
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="image"
                          label="Image"
                          valuePropName="fileList"
                          getValueFromEvent={(e) => e.fileList}
                        >
                          <Upload
                            name="image"
                            listType="picture"
                            beforeUpload={() => false}
                            maxCount={1}
                          >
                            <Button>Select Image</Button>
                          </Upload>
                        </Form.Item>
                      </Col>
                    </Row>
          
                    <Form.Item>
                      <div>
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{ marginRight: 8 }}
                        >
                          Update Faculty
                        </Button>
          
                        <Button
                          danger
                          onClick={() => {
                            navigation("/Users");
                          }}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Form.Item>
        </Form>
      </Spin>
    </App>
  );
};

export default UpdateUser;
